/**
 * Custom Cursor
 * Creates a custom cursor with follower and hover effects
 */

class CustomCursor {
  constructor() {
    this.cursor = document.getElementById('cursor');
    this.follower = document.getElementById('cursor-follower');
    this.pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    this.mouse = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    this.followerPos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    
    this.init();
  }
  
  init() {
    // Check for touch device
    if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
      this.cursor.style.display = 'none';
      this.follower.style.display = 'none';
      return;
    }
    
    this.setupEventListeners();
    this.animate();
  }
  
  setupEventListeners() {
    // Mouse move
    window.addEventListener('mousemove', (e) => {
      this.mouse.x = e.clientX;
      this.mouse.y = e.clientY;
      
      // Ensure visibility on move
      if (this.cursor.style.opacity === '0') {
        this.cursor.style.opacity = '1';
        this.follower.style.opacity = '1';
      }
    });
    
    // Hover effects on interactive elements
    const interactiveElements = document.querySelectorAll(
      'a, button, input, textarea, [data-magnetic]'
    );
    
    interactiveElements.forEach((el) => {
      el.addEventListener('mouseenter', () => this.onHover());
      el.addEventListener('mouseleave', () => this.onLeave());
    });
    
    // Hide cursor when leaving window
    document.addEventListener('mouseleave', () => {
      this.cursor.style.opacity = '0';
      this.follower.style.opacity = '0';
    });
    
    document.addEventListener('mouseenter', () => {
      this.cursor.style.opacity = '1';
      this.follower.style.opacity = '1';
    });
  }
  
  onHover() {
    this.cursor.classList.add('hover');
    this.follower.classList.add('hover');
  }
  
  onLeave() {
    this.cursor.classList.remove('hover');
    this.follower.classList.remove('hover');
  }
  
  animate() {
    // Smooth cursor following
    this.pos.x += (this.mouse.x - this.pos.x) * 0.2;
    this.pos.y += (this.mouse.y - this.pos.y) * 0.2;
    
    this.followerPos.x += (this.mouse.x - this.followerPos.x) * 0.1;
    this.followerPos.y += (this.mouse.y - this.followerPos.y) * 0.1;
    
    this.cursor.style.left = `${this.pos.x}px`;
    this.cursor.style.top = `${this.pos.y}px`;
    
    this.follower.style.left = `${this.followerPos.x}px`;
    this.follower.style.top = `${this.followerPos.y}px`;
    
    requestAnimationFrame(() => this.animate());
  }
}

export default CustomCursor;
